var en_AU = {};
module['exports'] = en_AU;
en_AU.title = "English (Australia)";
en_AU.name = require("./name");
en_AU.company = require("./company");
en_AU.internet = require("./internet");
en_AU.address = require("./address");
en_AU.phone_number = require("./phone_number");